import styled, { css } from 'styled-components';
import { ReactComponent as Cross } from '../../../assets/img/cross.svg';

export const StyledParagraphMobileRequired = styled.p`
  text-align: center;
  margin: 5px 0;
  line-height: 1.87;
  font-family: 'Archivo', sans-serif;
  font-size: 18px;
  margin-bottom: 2rem;
  color: ${({ theme }) => theme.text};

  ${({ lineHeight }) => {
    if (lineHeight) {
      return css`
        line-height: ${lineHeight};
      `;
    }
  }}
  ${({ small }) => {
    if (small) {
      return css`
        font-size: 13px;
      `;
    }
  }}
  ${({ aligned }) => {
    if (aligned) {
      return css`
        text-align: ${aligned};
      `;
    }
  }}
  ${({ customColor }) => {
    if (customColor) {
      return css`
        color: ${customColor};
      `;
    }
  }}
`;

export const StyledCrossMobileRequired = styled(Cross)`
  position: absolute;
  top: 25px;
  right: 25px;
  height: 16px;
  width: 16px;
  cursor: pointer;
  z-index: 2;
  path {
    fill: ${({ theme }) => theme.text};
  }
`;

export const StyledPopUpMobile = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 20;
  background: rgba(0, 0, 0, 0.8);
`;